import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import InventoryIcon from '@material-ui/icons/AddCircleTwoTone';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSnackbar } from 'notistack';

import {
  TextInput,
  AutoCompleteRemoto,
  SelectInput,
} from '../../../Components';
import { createAPI, updateAPI, getListAllAPI } from '../../../services';
import {
  STATUS_ATIVO,
  TURNO_MANHA,
  TURNO_NOITE,
  TURNO_12_HORAS,
} from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`codinome-tabpanel-${index}`}
      aria-labelledby={`codinome-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `codinome-tab-${index}`,
    'aria-controls': `codinome-tabpanel-${index}`,
  };
}

const DEFAULT_ID = -1;

const optionsTurno = [
  {
    label: 'Manhã',
    value: TURNO_MANHA,
  },
  {
    label: 'Noite',
    value: TURNO_NOITE,
  },
  {
    label: '12H',
    value: TURNO_12_HORAS,
  },
];

function getLabelFolga(grupo) {
  if (grupo) {
    if (!grupo.equipe_colaborador_id)
      return (
        <>
          <span
            style={{
              fontWeight: 'bold',
            }}
          >
            SS
          </span>
          <span>(folga no domingo)</span>
        </>
      );
    switch (grupo.dia_da_folga) {
      case 0:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga no domingo)</span>
          </>
        );
      case 1:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga na segunda-feira)</span>
          </>
        );
      case 2:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga na terça-feira)</span>
          </>
        );
      case 3:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga na quarta-feira)</span>
          </>
        );
      case 4:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga na quinta-feira)</span>
          </>
        );
      case 5:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga na sexta-feira)</span>
          </>
        );
      case 6:
        return (
          <>
            <span
              style={{
                fontWeight: 'bold',
              }}
            >
              Escalado
            </span>
            <span>(folga no sábado)</span>
          </>
        );
      default:
        return '';
    }
  }
  return '';
}

const GL1 = 'GL1';
const GL2 = 'GL2';
const GL3 = 'GL3';
const C1 = 'C1';

function getPodeEditar(codinome) {
  switch (codinome) {
    case GL1:
      return false;
    case GL2:
      return false;
    case GL3:
      return false;
    case C1:
      return false;
    default:
      return true;
  }
}

const DialogoCategoriaTransacao = forwardRef(({ handleClose }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [nome, setNome] = useState('');
  const [id, setId] = useState(DEFAULT_ID);
  const [funcao, setFuncao] = useState(null);
  const [turno, setTurno] = useState(TURNO_MANHA);
  const [grupo, setGrupo] = useState(null);
  //const [empresa, setEmpresa] = useState(null);
  //const [isFuncionarioInterno, setIsFuncionarioInterno] = useState(true);
  //const [empresaOriginalId, setEmpresaOriginalId] = useState(null);
  const [funcaoOriginalId, setFuncaoOriginalId] = useState(null);
  const [nomeOriginal, setNomeOriginal] = useState('');
  const [espelho, setEspelho] = useState(null);
  const [produtos, setProdutos] = useState([]);
  const [produtoTemp, setProdutoTemp] = useState(null);
  const [tab, setTab] = useState(0);
  const [produtosPage, setProdutosPage] = useState(0);
  const produtosPerPage = 20;
  const [produtoDialogOpen, setProdutoDialogOpen] = useState(false);

  const [carregando, setCarregando] = useState(false);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  async function reiniciar() {
    setId(DEFAULT_ID);
    setNome('');
    setCarregando(false);
    setGrupo(null);
    setTurno(TURNO_MANHA);
    setFuncao(null);
    setFuncaoOriginalId(null);
    //setIsFuncionarioInterno(true);
    //setEmpresa(null);
    //setEmpresaOriginalId(null);
    setNomeOriginal('');
    setEspelho(null);
    setProdutos([]);
    setProdutoTemp(null);
    setTab(0);
    setProdutosPage(0);
    setProdutoDialogOpen(false);
  }

  async function getDataResource(id) {
    try {
      const data = await getListAllAPI(
        'codinomes_colaborador',
        ['id', 'asc'],
        { id: [id] },
        [
          'funcao',
          'grupoColaborador',
          'produtos.produto',
          'espelho' /*'empresa'*/,
        ],
      );
      if (data.data.length > 0) {
        setId(data.data[0].id);
        setNome(data.data[0].nome);
        setCarregando(false);
        setFuncao(data.data[0].funcao);
        setFuncaoOriginalId(
          data.data[0].funcao ? data.data[0].funcao.id : null,
        );
        setGrupo(data.data[0].grupoColaborador);
        setFuncao(data.data[0].funcao);
        setTurno(data.data[0].turno);
        setEspelho(data.data[0].espelho || null);
        setProdutos(
          data.data[0].produtos
            ? data.data[0].produtos.map((p) => p.produto).filter(Boolean)
            : [],
        );
        //setIsFuncionarioInterno(data.data[0].is_funcionario_interno);
        //setEmpresa(data.data[0].empresa);
        /*setEmpresaOriginalId(
          data.data[0].empresa ? data.data[0].empresa.id : null,
        );*/
        setNomeOriginal(data.data[0].nome);
        setTab(0);
      } else {
        throw 'Este Codinome não existe!';
      }
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  async function handleSalvar() {
    setCarregando(true);
    try {
      if (id <= 0) {
        await createAPI('codinomes_colaborador', {
          nome,
          turno,
          grupo_colaborador_id: grupo ? grupo.id : null,
          //is_funcionario_interno: isFuncionarioInterno,
          funcao_colaborador_id: funcao ? funcao.id : null,
          //empresa_id: empresa ? empresa.id : null,
          codinome_colaborador_id:
            turno !== TURNO_MANHA ? (espelho ? espelho.id : null) : null,
          produtos: turno === TURNO_MANHA ? produtos.map((p) => p.id) : [],
        });
        setCarregando(false);
        enqueueSnackbar('Este codinome foi criado com sucesso!', {
          variant: 'success',
        });
      } else {
        await updateAPI('codinomes_colaborador', id, {
          nome,
          turno,
          grupo_colaborador_id: grupo ? grupo.id : null,
          //is_funcionario_interno: isFuncionarioInterno,
          funcao_colaborador_id: funcao ? funcao.id : null,
          //empresa_id: empresa ? empresa.id : null,
          codinome_colaborador_id:
            turno !== TURNO_MANHA ? (espelho ? espelho.id : null) : null,
          produtos: turno === TURNO_MANHA ? produtos.map((p) => p.id) : [],
        });
        setCarregando(false);
        enqueueSnackbar('Este Codinome foi atualizado com sucesso!', {
          variant: 'success',
        });
      }

      handleCloseDialog();
    } catch (erros) {
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleCreate() {
      reiniciar();
      setOpen(true);
    },
    handleEdit(id) {
      setCarregando(true);
      getDataResource(id);
      setId(id);
      setOpen(true);
    },
  }));

  function handleAddProduto() {
    if (!produtoTemp) return;
    if (produtos.find((p) => p.id === produtoTemp.id)) {
      enqueueSnackbar('Este produto já foi adicionado!', {
        variant: 'warning',
      });
      setProdutoTemp(null);
      return;
    }
    setProdutos([...produtos, produtoTemp]);
    setProdutoTemp(null);
    setProdutoDialogOpen(false);
  }

  function handleRemoveProduto(index) {
    const novosProdutos = produtos.filter((_, i) => i !== index);
    setProdutos(novosProdutos);
    const totalPaginas = Math.ceil(novosProdutos.length / produtosPerPage);
    if (produtosPage > 0 && produtosPage >= totalPaginas) {
      setProdutosPage(totalPaginas - 1);
    }
  }

  function validateNome() {
    let error = '';
    if (!nome) error = 'Este campo é obrigatório';
    else if (nome.length > 80) {
      error = 'Número de caracteres maior que o permitido (máximo 80)';
    }
    return error;
  }

  function validateFuncao() {
    let error = '';
    if (!funcao) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  function validateGrupo() {
    let error = '';
    if (!grupo) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }

  /*function validateEmpresa() {
    let error = '';
    if (!empresa) {
      error = 'Este campo é obrigatório';
    }
    return error;
  }*/

  function getErros() {
    const errosOld = [''];
    errosOld[0] = validateNome();
    errosOld[1] = validateFuncao();
    errosOld[2] = validateGrupo();
    //errosOld[3] = validateEmpresa();
    return errosOld;
  }

  const erros = getErros();

  function hasError() {
    for (let i = 0; i < erros.length; i += 1) {
      if (erros[i] !== '') return true;
    }
    return false;
  }

  const erroExistente = hasError();

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="lg"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          {id < 0 ? `Novo Codinome` : `Editar Codinome`}
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab label="Geral" {...a11yProps(0)} />
                <Tab
                  label={turno === TURNO_MANHA ? 'Produtos' : 'Espelho'}
                  {...a11yProps(1)}
                />
              </Tabs>
              <TabPanel value={tab} index={0}>
                <Box display="flex" mt="1em">
                  <Box flex={1} mr="0.5em">
                    <TextInput
                      name="nome"
                      handleEnter={() => {}}
                      label="Descrição"
                      handleKey={() => {}}
                      value={nome}
                      onChange={(value) => setNome(value.target.value)}
                      error={erros[0] !== ''}
                      helperText={erros[0]}
                      fullWidth
                      autoFocus
                      variant="outlined"
                      disabled={!getPodeEditar(nomeOriginal)}
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <AutoCompleteRemoto
                      handleEnter={() => {}}
                      label="Função"
                      handleKey={() => {}}
                      value={funcao}
                      onChange={(value) => setFuncao(value)}
                      fullWidth
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.nome === value.nome
                      }
                      getOptionLabel={(option) => `${option.nome}`}
                      nested={[]}
                      filters={
                        funcaoOriginalId
                          ? {
                              ids_incluso: [funcaoOriginalId],
                              status: STATUS_ATIVO,
                            }
                          : { status: STATUS_ATIVO }
                      }
                      resource="funcoes_colaboradores"
                      disabled={false}
                      error={erros[1] !== ''}
                      helperText={erros[1]}
                    />
                  </Box>
                </Box>
                <Box display="flex">
                  <Box flex={1} mr="0.5em">
                    <AutoCompleteRemoto
                      name="grupo"
                      label="Grupo"
                      value={grupo}
                      onChange={(value) => setGrupo(value)}
                      handleKey={() => {}}
                      handleEnter={() => {}}
                      resource="grupos_colaborador"
                      nested={[]}
                      toString={false}
                      fullWidth
                      error={erros[2] !== ''}
                      helperText={erros[2]}
                    />
                  </Box>
                  <Box flex={1} ml="0.5em">
                    <FormControl
                      variant="outlined"
                      style={{ marginTop: '16px' }}
                      className={classes.formControl}
                      fullWidth
                    >
                      <InputLabel shrink id="turno-colaborador">
                        Turno
                      </InputLabel>
                      <SelectInput
                        labelId="turno-colaborador"
                        name="turno"
                        handleEnter={() => {}}
                        label="Turno"
                        handleKey={() => {}}
                        value={turno}
                        onChange={(value) => {
                          const novoTurno = value.target.value;
                          if (
                            novoTurno !== TURNO_MANHA &&
                            produtos.length > 0
                          ) {
                            enqueueSnackbar(
                              'Remova os produtos associados antes de mudar o turno.',
                              { variant: 'warning' },
                            );
                            return;
                          }
                          if (novoTurno === TURNO_MANHA && espelho) {
                            enqueueSnackbar(
                              'Remova o codinome espelho antes de mudar para o turno manhã.',
                              { variant: 'warning' },
                            );
                            return;
                          }
                          setTurno(novoTurno);
                        }}
                        options={optionsTurno}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box display="flex" mt="10px">
                  <Box
                    flex={1}
                    mr="0.5em"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    {getLabelFolga(grupo)}
                  </Box>
                  <Box flex={1} ml="0.5em" />
                </Box>
              </TabPanel>
              <TabPanel value={tab} index={1}>
                {turno !== TURNO_MANHA ? (
                  <Box mt="1em">
                    <AutoCompleteRemoto
                      label="Codinome Espelho (Manhã)"
                      value={espelho}
                      onChange={(value) => setEspelho(value)}
                      handleKey={() => {}}
                      handleEnter={() => {}}
                      resource="codinomes_colaborador"
                      nested={['funcao', 'grupoColaborador']}
                      filters={{
                        status: STATUS_ATIVO,
                        turno: TURNO_MANHA,
                        sem_espelho: true,
                        ...(espelho ? { ids_incluso: [espelho.id] } : {}),
                      }}
                      toString={false}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => `${option.nome}`}
                      fullWidth
                      perPage={50}
                    />
                  </Box>
                ) : (
                  <>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      mt="1em"
                    >
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 'bold' }}
                      >
                        Produtos desse Codinome ({produtos.length})
                      </Typography>
                      <Tooltip title="Adicionar produto">
                        <IconButton
                          color="primary"
                          onClick={() => setProdutoDialogOpen(true)}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    <Divider style={{ margin: '12px 0' }} />
                    {produtos.length > 0 ? (
                      <TableContainer
                        component={Paper}
                        variant="outlined"
                        style={{ marginTop: '12px' }}
                      >
                        <Table size="small">
                          <TableHead>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                              <TableCell
                                style={{ fontWeight: 'bold', width: '100px' }}
                              >
                                ID
                              </TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>
                                Nome
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: 'bold', width: '100px' }}
                              >
                                Ações
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {produtos
                              .slice(
                                produtosPage * produtosPerPage,
                                produtosPage * produtosPerPage +
                                  produtosPerPage,
                              )
                              .map((produto) => {
                                const index = produtos.indexOf(produto);
                                return (
                                  <TableRow key={produto.id} hover>
                                    <TableCell>{produto.id}</TableCell>
                                    <TableCell>{produto.nome}</TableCell>
                                    <TableCell align="center">
                                      <Tooltip title="Remover produto">
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            handleRemoveProduto(index)
                                          }
                                        >
                                          <DeleteIcon
                                            fontSize="small"
                                            color="error"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                        <TablePagination
                          component="div"
                          count={produtos.length}
                          page={produtosPage}
                          onChangePage={(_, newPage) =>
                            setProdutosPage(newPage)
                          }
                          rowsPerPage={produtosPerPage}
                          rowsPerPageOptions={[]}
                          labelDisplayedRows={({ from, to, count }) =>
                            `${from}-${to} de ${count}`
                          }
                        />
                      </TableContainer>
                    ) : (
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        color="text.secondary"
                        mt="2em"
                        mb="1em"
                      >
                        <InventoryIcon style={{ fontSize: 48, opacity: 0.4 }} />
                        <Typography
                          variant="body2"
                          style={{ marginTop: '8px' }}
                        >
                          Nenhum produto associado a este codinome
                        </Typography>
                      </Box>
                    )}
                  </>
                )}
              </TabPanel>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <div className={classes.wrapper}>
            <Button
              onClick={handleSalvar}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              disabled={erroExistente || carregando}
              variant="contained"
              color="primary"
            >
              Salvar
            </Button>
            {carregando && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Dialog
        open={produtoDialogOpen}
        onClose={() => {
          setProdutoDialogOpen(false);
          setProdutoTemp(null);
        }}
        aria-labelledby="produto-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Transition}
      >
        <DialogTitle
          id="produto-dialog-title"
          onClose={() => {
            setProdutoDialogOpen(false);
            setProdutoTemp(null);
          }}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Adicionar Produto
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <Box mt="1em">
            <AutoCompleteRemoto
              label="Produto"
              value={produtoTemp}
              onChange={(value) => setProdutoTemp(value)}
              handleKey={() => {}}
              handleEnter={handleAddProduto}
              resource="produtos/search/autocomplete"
              nested={[]}
              filters={{
                status: STATUS_ATIVO,
                sem_codinome: true,
                ...(produtos.length > 0
                  ? { ids_excluso: produtos.map((p) => p.id) }
                  : {}),
              }}
              toString={false}
              getOptionSelected={(option, value) => option.id === value.id}
              getOptionLabel={(option) => `${option.nome}`}
              fullWidth
              autoFocus
            />
          </Box>
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          <Button
            onClick={handleAddProduto}
            disabled={!produtoTemp}
            classes={{
              root: classes.btnAtions,
              disabled: classes.btnAtionsDisabled,
            }}
            variant="contained"
            color="primary"
          >
            Adicionar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoCategoriaTransacao;
